module.exports = __webpack_public_path__ + "img/logoCollapsed.2b94cf0d.png";